/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Instant_SetupInputs */

const en_instant_setup = /** @type {(inputs: Instant_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Setup`)
};

const id_instant_setup = /** @type {(inputs: Instant_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyiapan Instan`)
};

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const es_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const fr_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const de_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const ja_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const zh_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const ar_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const it_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const ru_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const pt_instant_setup = en_instant_setup;

/** @type {(inputs: Instant_SetupInputs) => LocalizedString} */
const ko_instant_setup = en_instant_setup;

/**
* | output |
* | --- |
* | "Instant Setup" |
*
* @param {Instant_SetupInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const instant_setup = /** @type {((inputs?: Instant_SetupInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Instant_SetupInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_instant_setup(inputs)
	if (locale === "es") return es_instant_setup(inputs)
	if (locale === "fr") return fr_instant_setup(inputs)
	if (locale === "de") return de_instant_setup(inputs)
	if (locale === "ja") return ja_instant_setup(inputs)
	if (locale === "zh") return zh_instant_setup(inputs)
	if (locale === "ar") return ar_instant_setup(inputs)
	if (locale === "id") return id_instant_setup(inputs)
	if (locale === "it") return it_instant_setup(inputs)
	if (locale === "ru") return ru_instant_setup(inputs)
	if (locale === "pt") return pt_instant_setup(inputs)
	return ko_instant_setup(inputs)
});